import { createContext } from 'react';

export const CodeContext = createContext<string | undefined>(undefined);
